import { LatestUpdatesType } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';
import { useGetUploadedImageQuery } from '@Store/api/strapiApiSlice';
import { NewsIcon } from './NewsIcon';

import styles from './carousel-item.module.css';

interface CarouselItemProps {
  imageSrc: string;
  newsType: LatestUpdatesType;
  publishedAt: string;
  description: string;
  onClick: () => void;
}

const CarouselItem: React.FC<CarouselItemProps> = ({
  description,
  imageSrc,
  newsType,
  publishedAt,
  onClick,
}) => {
  const { data: strapiImage } = useGetUploadedImageQuery(imageSrc);
  return (
    <div className={styles.shorterPost} onClick={onClick}>
      <div className={styles.info}>
        <div className={styles.type}>
          {NewsIcon[newsType]}
          {newsType}
        </div>
        <div className={styles.desc}>{description}</div>
        <div className={styles.timePost}>
          {parseDateTime(publishedAt, 'DD.MM.YYYY HH:MM')}
        </div>
      </div>
      <img className={styles.imagePost} src={strapiImage} alt="News Post" />
    </div>
  );
};

export default CarouselItem;
